import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudGenericsService } from '../common/crud-generics';

import { Environment, ProcedureSegnalTipo, IProcedureSegnalTipoLng } from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class ProcedureSegnalTipoService extends CrudGenericsService<ProcedureSegnalTipo, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/ProcedureSegnalTipo`);
    this.base = `${env.apiUrl}/api/ProcedureSegnalTipo/`;
  }
  // web
  GetAll_ProcedureSegnalTipoLng(): Observable<IProcedureSegnalTipoLng[]> {
    const url = this.base + 'GetAll_ProcedureSegnalTipoLng';
    return this.http.get<IProcedureSegnalTipoLng[]>(`${url}`);
  }
}
